import * as types from "../mutation-types";

const state = {
    isTokenExpired: false
};

const mutations = {
    [types.SET_TOKEN_EXPIRED_STATUS](state, data) {
        state.isTokenExpired = data;
    }
};

export default {
    state,
    mutations
};
